<template>
  <div class="chat-window">
    <div v-if="error">{{ error }}</div>
    <div v-if="documents" class="messages" ref="messages">
      <div v-for="doc in formattedDocuments" :key="doc.id" class="single">
        <span class="created-at">{{ doc.createdAt }}</span>
        <span class="name">{{ doc.name }}:</span>
        <span class="message">{{ doc.message }}</span>
      </div>
    </div>
    <div v-else>
      <Spinner width="70" />
    </div>
    <div v-if="isMessageSending">
      <Spinner width="30" />
    </div>
  </div>
</template>

<script>
import getCollection from "../composables/getCollection";
import Spinner from "./Spinner.vue";
import { formatDistanceToNow } from "date-fns";
import { computed, onUpdated, ref, watch, watchEffect } from "vue";

export default {
  props: ["isMessageSending"],
  components: { Spinner },
  setup(props) {
    const { error, documents } = getCollection("messages");

    const formattedDocuments = computed(() => {
      if (documents.value) {
        return documents.value.map((doc) => {
          let time = formatDistanceToNow(doc.createdAt.toDate());
          return { ...doc, createdAt: time };
        });
      }
    });

    // auto-scroll to the bottom of the messages
    const messages = ref(null);

    onUpdated(() => {
      messages.value.scrollTop = messages.value.scrollHeight;
    });

    return { error, formattedDocuments, documents, messages };
  },
};
</script>

<style scoped>
.chat-window {
  background: rgb(240, 240, 240);
  padding: 30px 20px;
}
.single {
  margin: 18px 0;
}
.created-at {
  display: block;
  color: #999;
  font-size: 12px;
  margin-bottom: 4px;
}
.name {
  font-weight: bold;
  margin-right: 6px;
}
.messages {
  max-height: 400px;
  overflow: auto;
}
</style>
